// extracted by mini-css-extract-plugin
export default {"expandedContent":"ActivityLogCard_expandedContent__AmIeg","scrollContainer":"ActivityLogCard_scrollContainer__Zdi+s"};